import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useResetPasswordMutation } from '../store/authApi';
import toast from 'react-hot-toast';
import AuthLayout from './AuthLayout';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [resetPassword, { isLoading }] = useResetPasswordMutation();
  const token = searchParams.get('token');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) return toast.error('Invalid or missing reset token.');
    if (password !== confirm) return toast.error('Passwords do not match.');
    if (password.length < 6) return toast.error('Password must be at least 6 characters.');

    try {
      await resetPassword({ password, token }).unwrap();
      toast.success('Password reset successfully. You can now sign in.');
      navigate('/login');
    } catch (error: any) {
      toast.error(error?.data?.message || 'Failed to reset password.');
    }
  };

  const labelCls = "block text-xs font-display font-semibold text-trident-gray-600 uppercase tracking-wider mb-1.5";

  return (
    <AuthLayout isLogin>
      <h2 className="font-display font-extrabold text-3xl text-trident-gray-900 mb-2">New password</h2>
      <p className="text-trident-gray-500 mb-8">Create a strong password for your account.</p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className={labelCls}>New Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-field" placeholder="Min 6 characters" required minLength={6} />
        </div>
        <div>
          <label className={labelCls}>Confirm</label>
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input-field" placeholder="Retype password" required minLength={6} />
        </div>
        <button type="submit" disabled={isLoading} className="btn-primary w-full justify-center flex items-center gap-2 py-3 mt-2">
          {isLoading ? 'Resetting...' : 'Reset Password'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default ResetPassword;
